import React from 'react'
import { PaginationRenderItemParams } from '@mui/material'
import Pagination, { PaginationProps } from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'

interface CustomPaginationProps extends PaginationProps {
  total_count: number
  max_page_size: number
  page_number: number
  showFirstButton?: boolean
  showLastButton?: boolean
  handlePagination: (event: React.ChangeEvent<unknown>, page: number) => void
}

export const CustomPagination: React.FC<CustomPaginationProps> = ({
  total_count,
  max_page_size,
  page_number,
  handlePagination,
  showFirstButton = true,
  showLastButton = true,
  ...rest
}) => {
  const getDataTestAttribute = (item: PaginationRenderItemParams): string => {
    if (item.type === 'first') {
      return 'button to first page'
    } else if (item.type === 'previous') {
      return 'button to previous page'
    } else if (item.type === 'next') {
      return 'button to next page'
    } else if (item.type === 'last') {
      return 'button to last page'
    } else {
      return `button ${item.page} page`
    }
  }

  return (
    <Pagination
      count={Math.ceil(total_count / max_page_size)}
      page={page_number}
      onChange={handlePagination}
      showFirstButton={showFirstButton}
      showLastButton={showLastButton}
      data-testid='pagination'
      renderItem={(item) => (
        <PaginationItem
          {...item}
          data-testid={getDataTestAttribute(item)}
        />
      )}
      {...rest}
    />
  )
}
